export function setAll(state, { properties }) {
  state.properties = properties;
}

export function setProperty(state, { property }) {
  state.property = property;
}

export function setPropertyTransactions(state, { transactions }) {
  state.transactions = transactions;
}
